export { ButtonColor, FuncType, ButtonType, ButtonTooltip, } from './enum';
